import { serviceTypeConstants } from '../_constants/serviceType.constants';
const initialState =  {};
 function serviceTypeReducer(state = initialState, action) {
  switch (action.type) {
    case serviceTypeConstants.SERVICETYPE_SUCCESS:
      console.log("data",action.data)
      return {
         serviceType: action.data
         };
    default:
      return state
  }
}

export default serviceTypeReducer;